import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { validateSession, userInfo } from '../../API/APICalls';
import Loading from '../../Components/Loading';
import SnackbarShow from '../../Components/SnackbarShow';
import UserEditForm from '../../Components/Mailbox/UserEditForm';

const MailboxEditPage = () => {
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const [windowClose, setWindowClose] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState({ open: false, message: '', severity: '' });
    const { id } = useParams();
    const handleUserUpdated = async () => {
        await getUserInfo(id);
    };

    const getUserInfo = async (id) => {
        try {
            setLoading(true);
            const response = await validateSession(id);
            if (response.status === 200) {
                const user_details = await userInfo(id);
                window.sessionStorage.setItem('userData', JSON.stringify(user_details));
                const expiryTime = new Date(Date.now() + 7 * 60 * 1000).getTime();
                window.sessionStorage.setItem('expiry_time', expiryTime);
                setUser(user_details);
            } else {
                setSnackbarMessage({ open: true, message: response.data.message, severity: 'error' });
                setWindowClose(true);
            }
        } catch (error) {
            setSnackbarMessage({ open: true, message: 'Something went wrong. Please try again later.', severity: 'error' });
            setWindowClose(true);
            console.error('User information getting failed error: ', error);
        } finally {
            setLoading(false);
        };
    };

    useEffect(() => { getUserInfo(id) }, [id]);
    if (windowClose) {
        setTimeout(() => { window.close(); }, 6000);
    };

    let snackbarMessageComp = (snackbarMessage.open) ? (<SnackbarShow data={snackbarMessage} setSnackbarMessage={setSnackbarMessage} />) : null;
    let userDataComp = (user === undefined || user === null || Object.keys(user).length === 0) ? (
        <h1>User details not found or session is not valid.</h1>
    ) : (
        <UserEditForm id={id} user={user} setWindowClose={setWindowClose}  onUpdateSuccess={handleUserUpdated}/>
    );

    if (loading) {
        return <Loading />
    }

    return (
        <>
            {snackbarMessageComp}
            {userDataComp}
        </>
    );
};

export default MailboxEditPage;
